export interface ResearchDocument {
  id: string;
  title: string;
  description: string;
  icon: string;
  readTime: string;
  updated: string;
  filepath: string;
  category: 'models' | 'compliance' | 'techniques' | 'applications' | 'evidence';
}

export const researchDocuments: ResearchDocument[] = [
  {
    id: 'ai-models',
    title: 'AI Models Overview',
    description: 'Current state of AI models (GPT-5, Claude 4, Gemini 2.5) for healthcare with compliance status and recommendations',
    icon: '🤖',
    readTime: '15 min',
    updated: 'Oct 30, 2025',
    filepath: '/research/01-ai-models-october-2025.md',
    category: 'models'
  },
  {
    id: 'gdpr',
    title: 'GDPR Compliance',
    description: 'Requirements for treating Irish and EU patients with AI tools, including consent, security, and breach notification',
    icon: '🇪🇺',
    readTime: '20 min',
    updated: 'Oct 30, 2025',
    filepath: '/research/02-gdpr-compliance-healthcare-ai.md',
    category: 'compliance'
  },
  {
    id: 'hipaa',
    title: 'HIPAA Compliance',
    description: 'Requirements for treating US patients, including 2025 Security Rule updates and BAA requirements',
    icon: '🇺🇸',
    readTime: '25 min',
    updated: 'Oct 30, 2025',
    filepath: '/research/03-hipaa-compliance-healthcare-ai.md',
    category: 'compliance'
  },
  {
    id: 'prompting',
    title: 'AI Prompting Best Practices',
    description: 'Evidence-based techniques for healthcare professionals with templates and examples for OT practice',
    icon: '📝',
    readTime: '30 min',
    updated: 'Oct 30, 2025',
    filepath: '/research/04-ai-prompting-best-practices-2025.md',
    category: 'techniques'
  },
  {
    id: 'applications',
    title: 'AI Applications in OT',
    description: 'Practical tools, use cases, and implementation guidance with ROI calculations and success stories',
    icon: '🏥',
    readTime: '35 min',
    updated: 'Oct 30, 2025',
    filepath: '/research/05-ai-applications-in-occupational-therapy.md',
    category: 'applications'
  },
  {
    id: 'evidence',
    title: 'Evidence-Based Research',
    description: 'What the science says about AI effectiveness in OT and healthcare with recent studies and findings',
    icon: '📊',
    readTime: '25 min',
    updated: 'Oct 30, 2025',
    filepath: '/research/06-evidence-based-research-summary.md',
    category: 'evidence'
  }
];

export function getResearchDocument(id: string): ResearchDocument | undefined {
  return researchDocuments.find(doc => doc.id === id);
}

export function getResearchDocumentsByCategory(category: ResearchDocument['category']): ResearchDocument[] {
  return researchDocuments.filter(doc => doc.category === category);
}
